import { FadeIn } from "../FadeIn";
import { useT } from "../../lib/i18n";
import { SERVICE_TILES } from "../../lib/images";

export const ServicesSection = () => {
  const t = useT();

  return (
    <section data-testid="services-section" className="bg-ink">
      <div className="container-x py-16 md:py-20">
        <FadeIn>
          <div className="eyebrow mb-3">{t("services.eyebrow")}</div>
          <h2 className="font-display text-4xl sm:text-5xl md:text-7xl mb-10 md:mb-16 max-w-3xl">
            {t("services.heading1")}{" "}
            <span className="italic text-stone">{t("services.heading2")}</span>.
          </h2>
        </FadeIn>
      </div>
      {/* Mobile: horizontal scroll. Desktop: 4-col grid. */}
      <div
        className="flex md:grid md:grid-cols-2 lg:grid-cols-4 overflow-x-auto md:overflow-visible snap-x snap-mandatory scroll-pl-4 scrollbar-hide pb-4 md:pb-0 px-4 md:px-0 gap-3 md:gap-0"
        data-testid="services-scroller"
      >
        {SERVICE_TILES.map((s, i) => (
          <FadeIn key={s.key} delay={i * 0.1}>
            <div
              data-testid={`service-${s.key}`}
              data-cursor="VOIR"
              className="relative h-[440px] md:h-[480px] w-[82vw] sm:w-[60vw] md:w-auto flex-shrink-0 snap-start overflow-hidden group md:cursor-none rounded-md md:rounded-none"
            >
              <img
                src={s.img}
                alt={s.label}
                className="absolute inset-0 w-full h-full object-cover transition-transform duration-[1500ms] ease-[cubic-bezier(0.22,1,0.36,1)] group-hover:scale-[1.08]"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-ink via-ink/40 to-transparent group-hover:from-ink/95 transition-all duration-700" />
              <div className="absolute inset-0 p-6 md:p-8 flex flex-col justify-end">
                <div className="eyebrow mb-3">0{i + 1}</div>
                <h3 className="font-display text-3xl md:text-4xl mb-3">{s.label}</h3>
                <p className="text-bone/70 text-sm max-w-xs">{s.desc}</p>
              </div>
            </div>
          </FadeIn>
        ))}
      </div>
    </section>
  );
};
